var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbsUp = function SvgThumbsUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.73 20.5H7.213v-12l6.634-6.596.846.846q.156.155.259.413.103.256.103.483V3.9l-1.062 4.6h6.7q.714 0 1.26.547.549.547.548 1.26v1.616q0 .156-.04.337-.04.18-.09.336l-2.866 6.762q-.216.48-.721.811-.506.33-1.052.331M8.712 19h9.02q.105 0 .216-.058a.37.37 0 0 0 .169-.192L21 12v-1.692a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087h-8.597l1.254-5.48-4.639 4.619zm-1.5-10.5V10H4v9h3.212v1.5H2.5v-12z"
  })));
};
export default SvgThumbsUp;